import { ReactNode } from 'react'
import cx from 'classnames'

import Styles from './EmojiItem.module.scss'

interface Props {
  children: ReactNode
  className?: string
  emojiClassName?: string
  emoji: any
}

export const EmojiItem = ({ className = '', emoji, emojiClassName, children }: Props) => {
  return (
    <div className={cx(Styles.item, Styles[className])}>
      <span className={cx(Styles.emoji, emojiClassName)}>{emoji}</span>
      {children}
    </div>
  )
}
